/**
 * Created by sprout on 2018-03-05.
 */
// import * as util from '../utils/util';
(function ($) {
    "use strict";
    nc.lineage.mainNshop = function (options) {
        if (!options) return;
        const option = $.extend({
            wrap: null,
            sendData : null,
            device : null,
            global: global || window
        }, options);


        //console.log(  global.isTestServer() , option.device == 'ingame' );
        if( global.isTestServer() && option.device == 'ingame'  ) {
            $('.wrap-section-nshop').css('display','none');
            return;
        } else {
            init();
        }

        function init() { // render by data, condition
            setInstance(option.data);
        }

        function setInstance(data) {
            const _data = data;
            let tpl = ``;

            tpl += `<header><h2>${data.header}</h2></header>
                <article id="nshopRoll">
                    <div class="slick-item">
                `;

            $.each( data.items , function (idx, val) {

                if(idx==4 || idx==8) { tpl += ` </div><div class="slick-item"> `; }

                const isGrade = val.grade ? `<i class="grade_vip">${require('../../svg/grade.svg')}</i>` : ``;
                const isPoint = val.point ? `<i class="price_point">${require('../../svg/point.svg')}</i>` : ``;
                const nshopUrl = option.device == 'launcher' ? (val.url.replace(/lineagenshop.plaync.com/i, 'launcher-lineagenshop.plaync.com')).replace(/rc./i, 'rc-') : val.url ;

                tpl += `
                    <section class="nshop__item">
                        <a href="${nshopUrl}" data-index=${idx} onmousedown="eval(\'try{ _trk_clickTrace( \'EVT\', \'/리니지/메인N샵\' );}catch(_e){}\');"><span class="flag flag-${val.flag}"></span><dl><dd class="thumb"><img src="${val.thumbnail}" alert="${val.title}"></dd><dt>${val.title}</dt><dd class="price">${isGrade}${isPoint}<i class="price_ncoin">${require('../../svg/ncoin.svg')}</i><strong>${val.ncoin}</strong></dd></dl></a>
                        </section>
                        `;
            });

            tpl += `</article>
                </div>
                `;

            const articleWrap = option.wrap;


            articleWrap.append( tpl );
            setSlick();

        }
        function setSlick(){

            $('#nshopRoll').slick({
                dots: true,
                infinite: false,
                arrows: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 640,
                        slidesToShow: 2
                    }
                ]
            });

        }


        function showLoadingBar(flag) {
            if (flag) {
                $('.loading-bar').show();
            } else {
                $('.loading-bar').hide();
            }
        }
    };
}(jQuery));


// WEBPACK FOOTER //
// ./_src/js/main/main-nshop.js